var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadLimitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 681",
    fill: "#ababb1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 393",
    d: "M10 20a10 10 0 117.072-2.928A9.943 9.943 0 0110 20zm0-15l-5 5h3v4h4v-4h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21h-4c-1.047 0-2-.953-2-2v-3c0-.691.416-1.342 1-1.704V14c0-1.654 1.346-3 3-3s3 1.346 3 3v.296c.584.362 1 1.013 1 1.704v3c0 1.047-.953 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12c-1.1 0-2 .9-2 2v1c-.5 0-1 .5-1 1v3c0 .5.5 1 1 1h4c.5 0 1-.5 1-1v-3c0-.5-.5-1-1-1v-1c0-1.1-.9-2-2-2m1 3h-2v-1c0-.5.5-1 1-1s1 .5 1 1v1m-1-5a4.005 4.005 0 013.995 3.801C21.605 14.358 22 15.151 22 16v3c0 1.598-1.402 3-3 3h-4c-1.598 0-3-1.402-3-3v-3c0-.848.395-1.642 1.005-2.199A4.005 4.005 0 0117 10z",
    fill: "#fff"
  }))));
}
export default SvgUploadLimitIcon;